import { render, staticRenderFns } from "./addCompetition.vue?vue&type=template&id=5d6c5a58&scoped=true&"
import script from "./addCompetition.vue?vue&type=script&lang=ts&"
export * from "./addCompetition.vue?vue&type=script&lang=ts&"
import style0 from "./addCompetition.vue?vue&type=style&index=0&id=5d6c5a58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6c5a58",
  null
  
)

export default component.exports